class CheckOut extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid()
        };

        this.calcHeaderWidth = this.calcHeaderWidth.bind(this);
        this.scrollListener = this.scrollListener.bind(this);
    }

    componentDidMount() {
        this.calcHeaderWidth();

        $('#'+this.props.table).bind('updateContent', this.calcHeaderWidth);
        $('#'+this.props.container).on('scroll', this.scrollListener);
    }


    scrollListener() {

        var scrollTop = $('#'+this.props.container).scrollTop();

        if (scrollTop > 40) {
            $('#'+this.state.uuid).css({
                top : scrollTop
            })
        } else {
            $('#'+this.state.uuid).css({
                top : -100
            })
        }
    }

    calcHeaderWidth() {
        var table = this.props.table;
        var uuid = this.state.uuid;

        var headerWidth = new Array();
        var bodyWidth = new Array();

        $('#'+table+' thead tr:first').find('th').each(function (index) {
            headerWidth[index] = $(this).width() + parseInt($(this).css('padding-left')) + parseInt($(this).css('padding-right')) +2;
        });

        $('#'+table+' tbody tr:first').find('td').each(function (index) {
            bodyWidth[index] = $(this).width() + parseInt($(this).css('padding-left')) + parseInt($(this).css('padding-right')) +2;
        });

        var newSize = new Array();
        for (var i=0; i<=headerWidth.length; i++) {
            if (headerWidth[i] > bodyWidth[i])
                newSize.push(headerWidth[i])
            else
                newSize.push(bodyWidth[i]);
        }

        $('#'+uuid+' thead tr').find('th').each(function (index) {
            $(this).css('width', newSize[index]);
        });
    }

    render() {
        var headerArr = this.props.headerArr || [];

        return (
            <table
                className='sticky-header table-1'
                id={this.state.uuid}>

                <thead>
                    <tr>
                        { headerArr.map((item, i) => {
                            return (
                                <th>
                                    {item}
                                </th>
                            )
                        })}
                    </tr>
                </thead>
            </table>
        );
    }
}

export default CheckOut;


// WEBPACK FOOTER //
// ./ui_src/app/components/form/StickyHeader.react.jsx